/* EstheCeuti – chování videí (ec-video) */
if (!customElements.get('ec-video')) {
  customElements.define(
    'ec-video',
    class EcVideo extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;

        const v = this.video;
        v.muted = true;
        v.defaultMuted = true;
        v.playsInline = true;
        v.setAttribute('playsinline', '');
        v.removeAttribute('controls');
        v.removeAttribute('autoplay');

        this.mode = this.dataset.mode || 'click';
        v.loop = this.mode === 'click';

        v.addEventListener('playing', () => this.classList.add('is-playing', 'is-started'));
        ['pause', 'ended', 'error'].forEach((ev) =>
          v.addEventListener(ev, () => this.classList.remove('is-playing'))
        );

        const btn = this.querySelector('.ec-video__btn');
        if (btn) btn.addEventListener('click', () => this.toggle());

        this.soundBtn = this.querySelector('[data-sound]');
        if (this.soundBtn) {
          this.soundBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            v.muted = !v.muted;
            this.soundBtn.querySelector('span').textContent = v.muted ? '🔇' : '🔊';
            this.soundBtn.setAttribute('aria-label', v.muted ? 'Zapnout zvuk' : 'Vypnout zvuk');
            if (v.paused) this.play();
          });
        }

        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (this.mode === 'auto' && !reduced && 'IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  // přehrát jen jednou; po skončení čeká na kliknutí
                  if (!v.ended) this.play();
                } else if (!v.paused) {
                  v.pause();
                }
              });
            },
            { threshold: 0.35 }
          );
          this.observer.observe(this);
        }
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      play() {
        const v = this.video;
        v.preload = 'auto';
        if (v.ended || (v.duration && v.currentTime >= v.duration - 0.2)) v.currentTime = 0;
        const p = v.play();
        if (p && p.catch) p.catch(() => {});
      }

      toggle() {
        if (this.video.paused) this.play();
        else this.video.pause();
      }
    }
  );
}
